import {useSelector} from 'react-redux';

export function useCatalogs() {
  return useSelector((state) => state.i18nReducer.languages);
}
